import {useState, useRef, useEffect, useCallback} from 'react';

import {DropdownButton} from 'shells/button/dropdown-button/dropdown-button';
import {Popover} from 'shells/popover/popover';
import {RangeInput} from 'shells/range-input/range-input';

import {DataFieldWrapper} from '../../../core-entity/widgets/summary-widget/data-field-wrapper';

import styles from './lead-confidence.module.css';

interface Props {
    value: number;
    onUpdate: (arg1: number) => void;
}

export function LeadConfidence({value, onUpdate}: Props) {
    const [showConfidenceSlider, setShowConfidenceSlider] = useState<boolean>(false);
    const [leadConfidence, setLeadConfidence] = useState<number>(value);

    const confidenceRef = useRef<HTMLDivElement | null>(null);

    useEffect(() => {
        // If the confidence was missing and we have it now, load it into state.
        // This is needed so we can update the confidence only once when it changes.
        setLeadConfidence(value);
    }, [value]);

    const handleConfidencePopupBlur = useCallback(() => {
        setShowConfidenceSlider(false);
        onUpdate(leadConfidence);
    }, [leadConfidence, onUpdate]);

    return (
        <DataFieldWrapper
            label='Confidence'
            children={
                <>
                    <div ref={confidenceRef} className={styles['confidence-container']}>
                        <DropdownButton
                            label={`${leadConfidence}%`}
                            onClick={() => {
                                setShowConfidenceSlider(true);
                            }}
                        />
                    </div>
                    {showConfidenceSlider && (
                        <Popover
                            location='bottom'
                            onBlur={handleConfidencePopupBlur}
                            anchor={confidenceRef.current}
                        >
                            <div className='px-16 py-8'>
                                <RangeInput
                                    value={leadConfidence}
                                    onChange={(nextValue) => {
                                        setLeadConfidence(nextValue);
                                    }}
                                />
                            </div>
                        </Popover>
                    )}
                </>
            }
        />
    );
}
